var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 32.9q-1 0-1.675-.675T5.15 30.5q0-1 .675-1.675T7.5 28.15h12.55q1 0 1.7.675t.7 1.675q0 1.05-.7 1.725t-1.7.675Zm0-9.45q-1 0-1.675-.675T5.15 21.1q0-1 .675-1.675T7.5 18.75H28q1 0 1.675.675t.675 1.675q0 1-.675 1.675T28 23.45Zm0-9.4q-1 0-1.675-.675T5.15 11.7q0-1 .675-1.675T7.5 9.35H28q1 0 1.675.675t.675 1.675q0 1-.675 1.675T28 14.05Zm19.45 29.5q-.75-.7-.75-1.675 0-.975.7-1.675l4-4-4-4q-.75-.7-.75-1.65t.7-1.65q.7-.7 1.675-.7.975 0 1.675.7l4 4 4-4q.7-.7 1.65-.725.95-.025 1.65.675.7.7.7 1.675 0 .975-.7 1.675l-4 4 4 4q.75.7.775 1.65.025.95-.675 1.65-.75.7-1.725.7-.975 0-1.675-.7l-4-4-4 4q-.75.75-1.65.75-.9 0-1.6-.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistRemoveIcon);
export default __webpack_public_path__ + "static/media/playlistRemoveIcon.6d58f2ac0282237261397ce500ff7817.svg";
export { ForwardRef as ReactComponent };